<template>
  <div class="home__content home-favorites scrollable-pagination">
    <loader-dots v-if="showLoader" />

    <div class="home__header">
      <h1 class="home__title">Избранное</h1>
    </div>
    <nav class="home__list-nav">
      <div
        v-for="(label, key) in sectionLabels"
        :key="key"
        class="home__list-nav-item"
        :class="{ _active: key === section }"
        @click="handleSectionClicked(key)"
      >
        {{ label }}
      </div>
    </nav>

    <div class="home__list favorites">
      <div v-if="documents != null">
        <home-favorites-documents
          :documents="documents"
          :currentSectionIsPrivate="currentSectionIsPrivate"
        />
      </div>
      
      <ul v-if="folders != null">
        <home-favorites-folders
          v-for="folder in folders"
          :folder="folder"
          :currentSectionIsPrivate="currentSectionIsPrivate"
        />
      </ul>

    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import {
  FAVORITES_SECTION_COMMON,
  FAVORITES_SECTION_PRIVATE
} from '@src/api/user';

import LoaderDots from '@@/shared/loaders/LoaderDots';
import HomeFavoritesFolders from './HomeFavoritesFolders';
import HomeFavoritesDocuments from './HomeFavoritesDocuments';

const sectionLabels = {
  [FAVORITES_SECTION_PRIVATE]: 'Личные',
  [FAVORITES_SECTION_COMMON]: 'Общие'
};

export default {
  components: {
    LoaderDots,
    HomeFavoritesFolders,
    HomeFavoritesDocuments
  },

  data: () => ({
    section: FAVORITES_SECTION_PRIVATE,
    sectionLabels: sectionLabels,
    documents : [],
    folders : [],
    opened: false
  }),

  computed: {
    ...mapGetters({
      items: 'favoriteDocumentsWithFolders',
      itemsTotal: 'favoriteDocumentsTotal',
      showLoader: 'showLoader'
    }),
    currentSectionIsPrivate() {
      return this.section === FAVORITES_SECTION_PRIVATE;
    }
  },

  async created() {
    if( this.$route.query && this.$route.query.mode) {
      this.section = this.$route.query.mode;
    }
    await this.loadItems();
  },

  methods: {
    async loadItems() {
      await this.$store.dispatch('getFavoriteDocumentsWithFolders', {
        section: this.section
      });
      this.documents = this.getDocuments();
      this.folders = this.getFolders();
    },
    handleSectionClicked(section) {
      // Это нужно для восстановления состояния страницы при принудитеьном 
      // обновлении из браузера 
      this.$router.push({
        name: 'favorites',
        query: {
          mode: section
        }
      })
      this.section = section;
      this.loadItems();
    },
    getDocuments() {
      return this.items.length && this.items[0].documents ? this.items[0].documents : null;
    },
    getFolders() {
      return this.items.length && this.items[0].folders ? this.items[0].folders : null;
    }
  },

  metaInfo: {
    title: 'Избранное'
  }
};
</script>
